import { Component, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'topo-notifications-prefs-header',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <div style="width: 100%; display: flex; justify-content: center; align-items: center">
      <h5>{{ 'NOTIFICATION-PREFERENCES.NOTIFICATION-PREFERENCES-LABEL' | translate }}</h5>
    </div>
  `
})
export class NotificationPrefsHeaderComponent {}
